export default "__VITE_ASSET__G214IwAt__"